module.exports = __webpack_public_path__ + "img/content_make13.82b271d7.png";